import React, { useContext } from "react";
import XLabelField from "component/labelField/XLabelField";
import t from "module/translations";
import InventoryCheckContext from "module/inventoryCheck/context/InventoryCheckContext";
import { InventoryCheckInterface } from "module/inventoryCheck/types";

const InventoryCheckReportingNumberFieldContainer: React.FC = () => {
  const { entity } = useContext(InventoryCheckContext);
  const { reportingNumber } = entity as InventoryCheckInterface;

  return (
    <XLabelField
      {...{
        caption: t.inventoryCheck.reportingNumberText,
        label: reportingNumber,
      }}
    />
  );
};

export default React.memo(InventoryCheckReportingNumberFieldContainer);
